export { icons, type IconName, type SvgIconComponent } from './registry.generated';
export { Icon, getIconComponent, type IconProps } from './icon';
